import * as verifyInvoice from './verifyInvoice';
import * as internalOrder from './internalOrder';
import * as labelsReprint from './labelsReprint';
import * as invoicing from './invoicing';
import * as verifyBox from './verifyBox';
import * as checking from './checking';
import * as storage from './storage';
import * as close from './close';

const reducers = {
  ...close,
  ...checking,
  ...storage,
  ...invoicing,
  ...verifyBox,
  ...internalOrder,
  ...verifyInvoice,
  ...labelsReprint,
};

export default reducers;
